import type { RichText } from '@titularis/api-client';

/**
 * O que o revisor digitou, **preso ao artigo que o gerou**.
 *
 * A gaveta do comentário não desmonta entre um artigo e outro: ela troca o
 * artigo e continua montada, com o mesmo estado. Um rascunho solto, sem dono,
 * atravessava essa troca e reaparecia na caixa do artigo seguinte - com o
 * Salvar ativo por cima dele, a um clique de sobrescrever o comentário certo.
 * Guardar o `artigoId` junto é o que torna isso impossível: rascunho de outro
 * artigo não é rascunho nenhum aqui.
 */
export interface RascunhoDoComentario {
  artigoId: string;
  doc: RichText;
}

/** O rascunho que vale para o artigo aberto; o de outro artigo não conta. */
export const rascunhoDoArtigo = (
  rascunho: RascunhoDoComentario | null,
  artigoId: string | undefined,
): RichText | null =>
  rascunho !== null && artigoId !== undefined && rascunho.artigoId === artigoId
    ? rascunho.doc
    : null;

/**
 * O que a caixa de comentário mostra.
 *
 * O rascunho deste artigo tem precedência - é a revisão em curso. Sem ele, o
 * comentário como está salvo, que é o que o artigo recém-aberto tem a mostrar.
 */
export const conteudoDaCaixa = (
  rascunho: RascunhoDoComentario | null,
  artigoId: string | undefined,
  salvo: RichText | null | undefined,
): RichText | null => rascunhoDoArtigo(rascunho, artigoId) ?? salvo ?? null;
